// `primary` is the conceptual sibling of `$brand-black` in
// assets/styles/elements.scss (single source of truth). SCSS and TS cannot
// share a module, so this value is kept in sync by convention + the Plan-02 grep gate.
export const theme = {
  colors: {
    primary: "#1E1E1E", // D-01 near-black chrome (NOT yellow — yellow is the accent)
    secondary: "#6c757d",
  },
};
